import {TileLayout} from "@progress/kendo-react-layout"
import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import BookingInfoCard from "../../components/Dashboard/bookingInfoCard"
import DashboardFilters from "../../components/Dashboard/dashboardFilters"
import {PerformanceChart} from "../../components/Dashboard/performanceChart"
import {ProfitOrLossChart} from "../../components/Dashboard/profitOrLossChart"
import {StackBarChartTest} from "../../components/Dashboard/stackedBarChartTest"
import {SunburstChart} from "../../components/Dashboard/sunburstChart"
import {VehicleTypeView} from "../../components/Dashboard/vehicleTypeView"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"

const Dashboard = () => {
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    const dashboardDataPosition = [
        {col: 1, colSpan: 2, rowSpan: 2},
        {col: 3, colSpan: 4, rowSpan: 2},
        {col: 1, colSpan: 2, rowSpan: 2},
        {col: 3, colSpan: 2, rowSpan: 2},
        {col: 5, colSpan: 2, rowSpan: 2},
        {col: 1, colSpan: 6, rowSpan: 2},
    ]

    const tiles = [
        {
            header: <p className="mb-0 text-muted font-weight-bold">Overview</p>,
            body: <BookingInfoCard />,
            reorderable: false,
            resizable: false,
        },
        {
            header: <p className="mb-0 text-muted font-weight-bold">Bookings by Vehicle Types - Next 14 days</p>,
            body: <VehicleTypeView />,
            reorderable: false,
            resizable: false,
        },
        {
            header: <p className="mb-0 text-muted font-weight-bold">Profit and Loss - 12 months</p>,
            body: <ProfitOrLossChart />,
            reorderable: false,
            resizable: false,
        },
        {
            header: <p className="mb-0 text-muted font-weight-bold">Test Result - 12 months</p>,
            body: <SunburstChart />,
            reorderable: false,
            resizable: false,
        },
        {
            header: <p className="mb-0 text-muted font-weight-bold">Top 5 Tests - 12 months</p>,
            body: <StackBarChartTest />,
            reorderable: false,
            resizable: false,
        },
        {
            header: (
                <div className="d-flex justify-content-between m-0">
                    <p className="mb-0 text-muted font-weight-bold">Overall Performance</p>
                </div>
            ),
            body: <PerformanceChart />,
            reorderable: false,
            resizable: false,
        },
    ]

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem active>Dashboard</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <DashboardFilters />
            {selectedDealer && (
                <TileLayout
                    className="p-0 dashboard-tile"
                    columns={6}
                    rowHeight={240}
                    positions={dashboardDataPosition}
                    gap={{rows: 10, columns: 10}}
                    items={tiles}
                    ignoreDrag={e => !e.target.classList.contains("k-card-title")}
                />
            )}
        </>
    )
}

export default Dashboard
